import { Trans } from "react-i18next";import { cn } from "../../../lib/utils";
import { DAY_TYPE_OPTIONS, SHORT_OPTIONS } from "../constants/scheduleConfig";

export function WeekRow({ weekNumber, value, onChange, disabled = false }) {
  const resultLabel = DAY_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? "";

  return (
    <div className="flex items-center gap-3 flex-wrap">
     <span className="w-16 shrink-0 text-sm font-medium text-[var(--color-text-primary)] whitespace-nowrap">
       <Trans i18nKey="dateTime.week" /> {weekNumber}
     </span>

      <div className="inline-flex gap-2">
        {SHORT_OPTIONS.map((option) => {
          const isSelected = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              disabled={disabled}
              onClick={() => onChange(option.value)}
              className={cn(
                "h-9 px-3.5 inline-flex items-center gap-1.5 rounded-xl border text-xs font-semibold transition whitespace-nowrap",
                "disabled:opacity-50 disabled:cursor-not-allowed",
                isSelected ?
                "border-[var(--color-primary)] bg-[var(--color-primary)]/5 text-[var(--color-primary)]" :
                "border-[var(--color-text-border)] bg-white text-[var(--color-text-secondary)] hover:text-foreground"
              )}>
              
              <span
                className={cn(
                  "h-1.5 w-1.5 rounded-full",
                  isSelected ? "bg-[var(--color-primary)]" : "bg-[var(--color-text-secondary)]/40"
                )} />
              
              {option.label}
            </button>);

        })}
      </div>

      {resultLabel &&
      <span className="ml-auto h-9 px-3.5 inline-flex items-center rounded-xl bg-[var(--color-primary)]/5 text-xs font-semibold text-[var(--color-primary)] whitespace-nowrap">
          {resultLabel}
        </span>
      }
    </div>);

}
